import React, { Fragment, FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';

import AlertConstants from '../../constants/alert.constant';
import { Content, ContentWarning } from './styles';
import { useAlert } from '../../containers/Alert';
import { useOrder } from '../../hooks/order/useOrder';
import Warning from '../Warning';
import {
  PaymentType,
  OrderStatus,
  Order,
} from '../../requests/caipirinha-api/interfaces/order.interface';
import { isContainsServices } from '../../utils/isContainsService';
import footerHeight from '../../constants/footer.constant';

interface Props {
  order: Order;
}

const CancelAction: FunctionComponent<Props> = ({ order }) => {
  const {
    id: orderId,
    details: { payments },
    status: orderStatus,
  } = order;
  const { alert, close, setLoading } = useAlert();
  const { deleteOrder } = useOrder();
  const { push } = useHistory();
  let textButton =
    'Algum dado do pedido não corresponde ao combinado com o vendedor?';

  if (String(payments[0].id) === PaymentType.BOLETO) {
    textButton =
      'Você ainda não realizou o pagamento do boleto e algum dado do pedido não corresponde ao combinado com o vendedor?';
  } else {
    textButton =
      'Algum dado do pedido não corresponde ao combinado com o vendedor?';
  }

  const handleClick = () => {
    alert(
      AlertConstants.cancel(async () => {
        setLoading(true);
        const deleted = await deleteOrder(orderId);
        setLoading(false);
        if (deleted) {
          close();
          push(`/${orderId}/pedido-cancelado`, { order });
        }
      }),
    );
  };

  const getAdditionalFooterSpace = () =>
    isContainsServices(order) ? footerHeight * 2 : 0;

  return (
    <>
      {payments.map((payment) => (
        <Fragment key={payment.id}>
          {String(payment.id) === PaymentType.BOLETO && (
            <ContentWarning>
              <Warning data-cy="order-delivery-message">
                O prazo de entrega inicia-se após a confirmação do pagamento do
                boleto pelo banco, que pode levar até 3 dias úteis.
              </Warning>
            </ContentWarning>
          )}
          {(orderStatus === OrderStatus.AWAITING_PAYMENT ||
            orderStatus === OrderStatus.DENIED ||
            orderStatus === OrderStatus.AUTHORIZED) && (
            <Content
              height={getAdditionalFooterSpace()}
              data-cy="cancel-content"
            >
              {textButton}
              <button
                type="button"
                onClick={handleClick}
                data-cy="cancel-order-button"
              >
                Clique aqui para cancelar
              </button>
            </Content>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default CancelAction;
